"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _useResponsiveQuery = require("@eig-builder/core-utils/hooks/useResponsiveQuery");

var _CircularProgress = _interopRequireDefault(require("@eig-builder/core-ui/CircularProgress"));

var _modalRoot = _interopRequireDefault(require("@eig-builder/module-modals/containers/modal-root"));

var _withModalContext = require("@eig-builder/module-modals/withModalContext");

var _moduleNotificationBarWithContext = require("@eig-builder/module-notification-bar-with-context");

var _error = _interopRequireDefault(require("./error/"));

var _reactErrorBoundary = _interopRequireDefault(require("react-error-boundary"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var WrapperDiv = _styledComponents["default"].div(_templateObject());

var DrawerDiv = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.drawerIsOpen ? '230px' : 'initial';
});

var ConditionalNotificationBarWrap = function ConditionalNotificationBarWrap(props) {
  if ((0, _runtimeConfigHelper.getRuntimeConfig)().version === 2) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children);
  }

  return /*#__PURE__*/_react["default"].createElement(_moduleNotificationBarWithContext.NotificationBarWrapperWithContext, null, /*#__PURE__*/_react["default"].createElement(_moduleNotificationBarWithContext.NotificationBarContainer, {
    targetKey: "fullscreen"
  }), props.children);
};

ConditionalNotificationBarWrap.propTypes = {
  children: _propTypes["default"].any
};
/**
 * PageContent is the content of the Navigation structure. It Renders the children,
 * when the route has subPages aka tabs, then the tabs will be shown. The children
 * ignored.
 */

var PageContent = function PageContent(_ref) {
  var children = _ref.children,
      renderChildren = _ref.renderChildren,
      renderRoutes = _ref.renderRoutes,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "renderChildren", "renderRoutes"]);

  var _useContext = (0, _react.useContext)(_wrapperContext["default"]),
      hideNavBar = _useContext.hideNavBar,
      isFocusView = _useContext.isFocusView,
      drawerIsOpen = _useContext.drawerIsOpen,
      activePage = _useContext.activePage,
      context = (0, _objectWithoutProperties2["default"])(_useContext, ["hideNavBar", "isFocusView", "drawerIsOpen", "activePage"]);

  var isMobile = (0, _useResponsiveQuery.useIsMobile)();
  var amountOfDetailBars = props.amountOfDetailBars || context.amountOfDetailBars;
  var FixedComponent = activePage && activePage.fixedComponent;
  var shouldRenderChildren = renderChildren || !activePage || !activePage.subPages || activePage.path === window.location.pathname;
  var shouldRenderRoutes = !shouldRenderChildren || renderRoutes;
  var stateClasses = (0, _classnames["default"])('core-components-app-wrapper', {
    'drawer-open': drawerIsOpen && !isFocusView,
    'navbar-open': !hideNavBar,
    desktop: !isMobile,
    mobile: isMobile
  });
  return /*#__PURE__*/_react["default"].createElement(WrapperDiv, {
    className: stateClasses
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "app-wrapper-body"
  }, /*#__PURE__*/_react["default"].createElement(_withModalContext.ModalContextProviderWrapper, null, /*#__PURE__*/_react["default"].createElement(ConditionalNotificationBarWrap, null, /*#__PURE__*/_react["default"].createElement(_modalRoot["default"], null), /*#__PURE__*/_react["default"].createElement(_reactErrorBoundary["default"], {
    FallbackComponent: function FallbackComponent() {
      return /*#__PURE__*/_react["default"].createElement(DrawerDiv, {
        style: {
          marginTop: amountOfDetailBars * 64
        },
        drawerIsOpen: drawerIsOpen
      }, /*#__PURE__*/_react["default"].createElement(_error["default"], null));
    }
  }, /*#__PURE__*/_react["default"].createElement(DrawerDiv, {
    style: {
      marginTop: amountOfDetailBars * 64
    },
    drawerIsOpen: drawerIsOpen
  }, shouldRenderChildren && children, shouldRenderRoutes && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, FixedComponent && /*#__PURE__*/_react["default"].createElement(FixedComponent, null), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
      centered: true,
      withPadding: true
    })
  }, activePage.subPages && activePage.subPages.map(function (route) {
    var LazyComponent = (0, _react.lazy)(route.component);
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      key: route.path,
      path: route.path,
      component: function component(props) {
        return /*#__PURE__*/_react["default"].createElement(LazyComponent, props);
      }
    });
  }))))))))));
};

PageContent.propTypes = {
  children: _propTypes["default"].node.isRequired,
  amountOfDetailBars: _propTypes["default"].number,
  // this can be used when the context cannot find the nav children throughout the dependency tree, ask bart when you encounter that, only then you can override it with this prop.
  renderChildren: _propTypes["default"].bool,
  renderRoutes: _propTypes["default"].bool
};
var _default = PageContent;
exports["default"] = _default;